module.exports = __webpack_public_path__ + "static/media/shreya-photo.dfc9024f.jpeg";